import i18n from '../i18n'
import { faDigits } from './numerals'

/**
 * The version footer of the design («طوطی نسخهٔ ۱٫۰٫۰ · بیلد ۱۰۴»), read
 * from the build and never typed: `__APP_VERSION__` is `package.json`'s
 * version injected by `vite.config.js`, and the build is whatever
 * `VITE_BUILD_SHA` the build environment provides (the deploy's commit),
 * left out when it is not known rather than invented.
 */
export const APP_VERSION = typeof __APP_VERSION__ === 'string' ? __APP_VERSION__ : '0.0.0'
export const BUILD_SHA = String(import.meta.env?.VITE_BUILD_SHA ?? '').trim()

/** A version the design's way in fa: Persian digits, Arabic decimal separator, `1.0.0` → `۱٫۰٫۰`. Latin, unchanged, in en. */
export function faVersion(version) {
  if (i18n.language !== 'fa') return version
  return faDigits(version).replace(/\./g, '٫')
}

export function appVersionLine() {
  const version = faVersion(APP_VERSION)
  if (!BUILD_SHA) return i18n.t('versionLine', { ns: 'common', version })
  return i18n.t('versionLineWithBuild', { ns: 'common', version, build: BUILD_SHA.slice(0, 7) })
}
